<template>
  <Header header__white="header__white" />
  <Breadcrumb title="Oportunidades" subtitle="Oportunidades" />
  <WhatArea />
  <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Inicio/Header.vue';
import Breadcrumb from '../components/Inicio/Breadcrumb.vue';
import Footer from '../components/Inicio/Footer.vue';
import WhatArea from '../components/Inicio/Opcoes.vue';

export default {
  name: 'OportunidadesPage',
  components: {
    Header,
    Breadcrumb,
    WhatArea,
    Footer,
  }
}
</script>
